import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import useConfigs from "../../hooks/useConfigs";
import useThemes from "../../hooks/useThemes";

const StyledHero = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: -2vh;
  min-height: 45vh;
  padding: 10vh 10vw 40vh 10vw;
  background-size: cover;
  background-position: center;
  background-image: url(${(props) => props.imgsrc});
  overflow: hidden;
  width: 100%;

  h1 {
    font-size: ${(props) => 100 * props.fontsizemultiplier};
    color: #fff;
    max-width: 80%;
    padding-top: 3rem;
    text-align: center;
  }

  h4 {
    font-size: ${(props) => 28 * props.fontsizemultiplier};
    text-transform: uppercase;
    color: #fff;
    max-width: 80%;
    text-align: center;
  }

  .img-container {
    position: absolute;
    bottom: -5vh;
    right: -10rem;
    max-width: 35rem;
    overflow: hidden;
    z-index: 4;

    img {
      width: 100%;
      height: auto;
    }
  }

  .transparencia{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 500px;
    padding-top: 2rem;
    
    position: absolute;
    z-indez: 2;
    background-color: var(--transparencia-banners);
  }

  @media (max-width: 1023px) {
    min-height: 33vh;
    padding: 5vh 5vw 10vh 5vw;

    h1 {
      font-size: ${(props) => 50 * props.fontsizemultiplier};
      text-align: center;
    }

    h4 {
      display: none;
    }

    .img-container {
      max-width: 18rem;
      bottom: -10vh;
      right: -5rem;
    }
  }

  .transparencia{
    min-height: 40vh;
    height: 200%;
  }
`;

const Svg = styled.svg`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
`;

const Hero = ({ title, subtitle, color, imgSrc }) => {
  const { fontSizeMultiplier } = useConfigs();
  const { imgLineas } = useThemes();

  return (
    <StyledHero fontsizemultiplier={fontSizeMultiplier} imgsrc={imgSrc}>
      <div className="transparencia">
        <h1>{title}</h1>
        <h4>{subtitle}</h4>
      </div>
      
        <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill={color}
            d="M0,224L80,218.7C160,213,320,203,480,213.3C640,224,800,256,960,245.3C1120,235,1280,181,1360,154.7L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </Svg>
        <div className="img-container">
          <img src={imgLineas} alt="lineas" />
        </div>
    </StyledHero>
  );
};

export default Hero;

Hero.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  imgSrc: PropTypes.string,
};
